import { gql } from 'src/generated/gql';

export const SEND_DENIAL_NOTICE = gql(`
  mutation SendDenialNotice($patientId: String!, $reason: String!) {
    staff_sendDenialNotice(patientId: $patientId, reason: $reason)
  }
`);
